import { Stack } from 'expo-router';
import { ScrollView } from 'react-native';
import { clsx } from 'clsx';

import NotFound from '../404';
import { Container } from '../container';
import { MarkdownTheme } from '../MarkdownTheme';
import Newsletter from '../newsletter';

import { BlogHead } from './blog-head';
import { useData } from './use-data';

type Props = {
  mdxctx: any;
  postId: string;
  basePath?: string;
  components?: Record<string, React.ComponentType<any>>;
  showNewsletter?: boolean;
};

export default function Page({
  mdxctx,
  postId,
  basePath = 'articles',
  components,
  showNewsletter = true,
}: Props) {
  const data = useData(postId, mdxctx);

  if (!data) {
    return <NotFound />;
  }

  const { MarkdownComponent, info } = data;

  return (
    <Container size="md">
      <BlogHead info={info} basePath={basePath} />
      <Stack.Screen
        options={{
          title: info.title,
        }}
      />

      <ScrollView
        contentInsetAdjustmentBehavior="automatic"
        contentContainerStyle={{
          paddingVertical: 24,
        }}
      >
        <div className={clsx('flex flex-1 flex-col min-w-full')}>
          <MarkdownTheme components={components}>
            <MarkdownComponent />
            {showNewsletter && <Newsletter showTitle />}
          </MarkdownTheme>
        </div>
      </ScrollView>
    </Container>
  );
}
